export default __webpack_public_path__ + "static/screen-724bdb1c19bdf6199ab0df3c39633ec2.png";